import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=4952be1b"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"
import style0 from "./Extras.vue?vue&type=style&index=0&id=4952be1b&prod&lang=css"
import style1 from "./Extras.vue?vue&type=style&index=1&id=4952be1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports